export const aNamed2 = "a-named2";



// WEBPACK FOOTER //
// ./src/mod6.js